import type { RouteRecordRaw } from "vue-router";
import { TOKEN } from "@/global/constant";
import useAccount from "@/store/modules/account";
import cache from "@/utils/cache";
import { routes } from "@/router/routes";
import { MenuItem } from "@/types/system/menu";

export function useSetAccount() {
  const accountStore = useAccount();
  const token = cache.getCache(TOKEN);
  token && accountStore.setToken(token);
  return [token];
}

export function useRegisterRoutes(menus: MenuItem[]) {
  const result: RouteRecordRaw[] = [];
  for (const menu of menus) {
    const parentRoute = routes.find((r) => r.path === menu.path);
    if (parentRoute) {
      const children: RouteRecordRaw[] = [];
      for (const menuChildren of menu.children) {
        const childrenRoute = parentRoute.children?.find(
          (r) => r.path === menuChildren.path.split("/")[2]
        );
        if (childrenRoute) {
          children.push(childrenRoute);
        }
      }
      result.push({ ...parentRoute, children });
    }
  }
  return result;
}
